import React, { useEffect, useRef, useState } from 'react';

function MediaDisplay({ poster, priority = false, src, title, type }) {
  const containerRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(priority);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (priority) {
      setShouldLoad(true);
      return undefined;
    }

    const element = containerRef.current;
    if (!element || typeof IntersectionObserver === 'undefined') {
      setShouldLoad(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { rootMargin: '400px 0px' },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [priority]);

  const previewSource = type === 'video' ? poster : src;
  const showPreview = shouldLoad && previewSource;

  return (
    <div
      ref={containerRef}
      className="flex flex-col overflow-hidden p-2 border border-custom_stroke-200 bg-custom_BG-200 rounded-lg"
    >
      {(!shouldLoad || (showPreview && isLoading)) && !hasError ? (
        <div className="w-full h-48 bg-gray-300 animate-pulse rounded-md" />
      ) : null}

      {showPreview && !hasError ? (
        <img
          src={previewSource}
          alt={title}
          className={`${isLoading ? 'hidden' : 'block'} min-w-[200px] max-w-[600px] object-cover rounded-md`}
          loading={priority ? 'eager' : 'lazy'}
          fetchPriority={priority ? 'high' : 'auto'}
          onLoad={() => setIsLoading(false)}
          onError={() => {
            setHasError(true);
            setIsLoading(false);
          }}
        />
      ) : type === 'video' && shouldLoad ? (
        <div className="flex h-48 items-center justify-center rounded-md bg-gray-300 text-sm text-zinc-700">
          Video preview
        </div>
      ) : null}

      {hasError ? (
        <div className="flex h-48 items-center justify-center rounded-md bg-gray-300 text-sm text-zinc-700">
          Preview unavailable
        </div>
      ) : null}
      <div className="pt-2">
        <h3 className="text-base font-Zilla leading-8 text-zinc-800">{title}</h3>
      </div>
    </div>
  );
}

export default MediaDisplay;